import * as React from 'react';
// import {Platform} from 'react-native';
import {Text} from '../text';
import {IStateProps} from './model';
// import {Link} from '../link';
// import {Screens} from '../../routing';

export default (props: IStateProps) => {
  const {style, text, onPress, loading, showLoadingText = true} = props;
  // TODO: VebView mode
  // if (!isDownloadable) {
  //   return (
  //     <Link screen={Screens.WebView} href={link} navigate={navigate} external={Platform.OS === 'web'}>
  //       <Text style={style}>{text}</Text>
  //     </Link>
  //   );
  // }

  return (
    <Text testID={props.testID} onPress={onPress} style={style}>
      {loading && showLoadingText ? 'Документ загружается ...' : text}
    </Text>
  );
};
